
import React from 'react';
import { Grid, Typography } from '@mui/material';

function Tutorial({ }) {
    return (
        <Grid sx={styles.GridContainer}>
            <Grid
                sx={styles.Title}>
                <Typography>
                    Tutorial
                </Typography>
                <Typography>
                    Aprenda aqui<br />
                    como tratar os <br />
                    registros de<br />
                    ponto de seus<br />
                    colaboradores
                </Typography>
            </Grid>
        </Grid>
    )
}

export default Tutorial;

const styles = ({
    GridContainer: {
        width: '190px',
        backgroundColor: '#FFF',
        borderRadius: '16px',
        boxShadow: 'rgba(0, 0, 0, 0.1) -2px 9px 12px',
        marginLeft: '15px',
        width: '220px',
        height: '95%'
    },
    Title: {
        width: '200px',
        height: '95%',
        backgroundColor: '#537ccd',
        margin: '9px 9px 9px 9px',
        textAlign: 'center',
        borderRadius: '16px',
        paddingTop: '20px',
        color: '#FFF'
    }
});